import { CSSObject, GlobalStyles } from '@mui/material';
import { FC } from 'react';
import { theme } from 'thermia-react-container';
import { config } from '../../config';
import { StoplightElements } from './stoplight-elements';

const ExplorePage: FC = () => (
  <div id="explore-page">
    <GlobalStyles styles={globalStyles} />
    <StoplightElements
      options={{ apiDescriptionUrl: config.openApiSpecUrl, router: 'hash', hideSchemas: true, hideExport: true }}
      storeFields={['serialNumber']}
      styles={themeStyles}
    />
  </div>
);

const themeStyles: CSSObject = {
  '--color-canvas-100': theme.palette.backgroundExtraLight.main
};

const globalStyles: CSSObject = {
  'body:has(div#explore-page)': {
    // Remove forced scroll on body, since we will use a two-scroll-bars layout for stoplight elements we will othervise end up with double scrollbars
    overflowY: 'visible !important' // unfortunately must use important since the style we want to override is applied inline
  },
  'div:has(div#explore-page)': {
    // Remove default margin and padding so stoplight elements can use the full page
    margin: 0,
    padding: 0,
    maxWidth: 'none'
  }
};

export default ExplorePage;
